import { LinkOff } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";

import { EnrichedShift } from "../../../../hooks/data-transform-utils/timelineEnrichment";
import { RouteDetailPanelTimelineFieldworkerActivity } from "../../../RouteDetailPanelTimelineFieldworkerActivity";
import { TravelTimelineItemShiftFragment } from "./fragments.generated";

interface TravelTimelineItemProps {
    pickups?: EnrichedShift[];
    dropoffs?: TravelTimelineItemShiftFragment[];
    ownerFieldworkerId?: string;
    onRemovePickupPointClick: (shiftId: string) => void;
    loadingToRemoveShiftId: string | null;
}

export function TravelTimelineItem({
    pickups,
    dropoffs,
    ownerFieldworkerId,
    onRemovePickupPointClick,
    loadingToRemoveShiftId,
}: TravelTimelineItemProps) {
    return (
        <Stack rowGap={1} flexGrow={1}>
            {pickups?.map(shift => (
                <Stack
                    key={shift.fieldworker.id}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="start"
                    sx={{
                        textDecoration: loadingToRemoveShiftId === shift.id ? "line-through" : "none",
                        opacity: loadingToRemoveShiftId === shift.id ? 0.5 : 1,
                    }}
                >
                    <RouteDetailPanelTimelineFieldworkerActivity
                        firstName={shift.fieldworker.user.firstName}
                        lastName={shift.fieldworker.user.lastName}
                        profilePictureMediaUrl={shift.fieldworker.user.profilePictureMedia?.url}
                        activityKey={shift.fieldworker.id === ownerFieldworkerId ? "departs" : "isPickedUp"}
                    />
                    {/*
                        only allow remove when fw has traveled to get to this point
                        (dont make fw homeless, dont displace drivers)
                    */}
                    {shift.pickupLocation?.shiftHasSecondaryTravel && (
                        <Button
                            variant="outlined"
                            size="small"
                            disabled={loadingToRemoveShiftId === shift.id}
                            color="inherit"
                            onClick={() => onRemovePickupPointClick(shift.id)}
                            sx={theme => ({
                                minWidth: "auto",
                                color: theme.palette.text.primary,
                            })}
                        >
                            <LinkOff fontSize="small" />
                        </Button>
                    )}
                </Stack>
            ))}

            {dropoffs?.map(shift => (
                <RouteDetailPanelTimelineFieldworkerActivity
                    key={shift.fieldworker.id}
                    firstName={shift.fieldworker.user.firstName}
                    lastName={shift.fieldworker.user.lastName}
                    profilePictureMediaUrl={shift.fieldworker.user.profilePictureMedia?.url}
                    activityKey={shift.fieldworker.id === ownerFieldworkerId ? "arrives" : "isDroppedOff"}
                />
            ))}
        </Stack>
    );
}
